import { LocalizedLink as Link } from '../components/LocalizedLink';
import { useEffect } from 'react';
import SEO from '../components/SEO';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import './LegalPage.css';
import { useTranslation } from "react-i18next";

export default function PrivacyPolicyPage() {
    const { t } = useTranslation();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page">
      <SEO 
        title={t('common.privacyPolicy')}
        description="Learn how Reviio collects, uses, and protects your personal data."

      />
      {/* Navbar */}
      <SiteHeader variant="solid" />

      {/* Header */}
      <div className="legal-container">
        <div className="legal-header">
          <h1>{t('common.privacyPolicy')}</h1>
          <p className="legal-meta">
            <strong>{t('common.effectiveDate')}</strong>{' ' + t('common.june222026NbspNbsp')}<strong>{t('common.lastUpdated')}</strong>{' ' + t('common.june222026')}</p>
        </div>

        {/* TOC */}
        <div className="legal-toc">
          <h4>{t('common.tableOfContents')}</h4>
          <ol>
            <li><a href="#pp-1">{t('legal.privacy.introductionAmpWhoWeAre')}</a></li>
            <li><a href="#pp-2">{t('legal.privacy.scopeOfThisPolicy')}</a></li>
            <li><a href="#pp-3">{t('legal.privacy.informationWeCollect')}</a></li>
            <li><a href="#pp-4">{t('legal.privacy.howWeUseYourInformation')}</a></li>
            <li><a href="#pp-5">{t('legal.privacy.googleApiServicesLimitedUseDisclosure')}</a></li>
            <li><a href="#pp-6">{t('legal.privacy.legalBasesForProcessingGdpr')}</a></li>
            <li><a href="#pp-7">{t('legal.privacy.dataSharingAmpThirdPartyServices')}</a></li>
            <li><a href="#pp-8">{t('legal.privacy.internationalDataTransfers')}</a></li>
            <li><a href="#pp-9">{t('legal.privacy.dataRetentionAmpDeletion')}</a></li>
            <li><a href="#pp-10">{t('legal.privacy.dataSecurity')}</a></li>
            <li><a href="#pp-11">{t('legal.privacy.yourRights')}</a></li>
            <li><a href="#pp-12">{t('legal.privacy.childrenRsquoSPrivacy')}</a></li>
            <li><a href="#pp-13">{t('common.changesToThisPolicy')}</a></li>
            <li><a href="#pp-14">{t('common.contactUs')}</a></li>
          </ol>
        </div>

        {/* Content */}
        <div className="legal-content">

          {/* 1 */}
          <h2 id="pp-1">{t('legal.privacy.1IntroductionAmpWhoWeAre')}</h2>
          <p>{' ' + t('legal.privacy.reviioLdquoReviioRdquoLdquoWe')}</p>
          <p>{' ' + t('legal.privacy.thisPrivacyPolicyDescribesHowReviio')}</p>

          {/* 2 */}
          <h2 id="pp-2">{t('legal.privacy.2ScopeOfThisPolicy')}</h2>
          <p>{' ' + t('legal.privacy.thisPrivacyPolicyAppliesToAll')}</p>

          {/* 3 */}
          <h2 id="pp-3">{t('legal.privacy.3InformationWeCollect')}</h2>

          <h3>{t('legal.privacy.31AccountInformationProvidedBy')}</h3>
          <p>{t('legal.privacy.whenYouRegisterForAnAccount')}</p>
          <ul>
            <li><strong>{t('legal.privacy.personalIdentifiers')}</strong>{' ' + t('legal.privacy.fullNameEmailAddressPasswordStored')}</li>
            <li><strong>{t('legal.privacy.businessInformation')}</strong>{' ' + t('legal.privacy.businessLegalNameBillingAddressBilling')}</li>
            <li><strong>{t('legal.privacy.subscriptionAndPlanSelections')}</strong></li>
          </ul>

          <h3>{t('legal.privacy.32GoogleAccountDataObtained')}</h3>
          <p>{' ' + t('legal.privacy.whenYouConnectYourGoogleBusiness')}<code>{t('common.httpsWwwGoogleapisComAuthBusiness')}</code>{t('legal.privacy.throughThisAuthorizationWeAccess')}</p>
          <ul>
            <li><strong>{t('legal.privacy.googleBusinessProfileAccountsAndLocation')}</strong>{' ' + t('legal.privacy.accountResourceNamesLocationNamesAddress')}</li>
            <li><strong>{t('legal.privacy.reviews')}</strong>{' ' + t('legal.privacy.reviewIdsReviewerDisplayNamesStar')}</li>
            <li><strong>{t('legal.privacy.replyPublishingCapability')}</strong>{' ' + t('legal.privacy.theAbilityToCreateUpdateAnd')}</li>
            <li><strong>{t('legal.privacy.oauthTokens')}</strong>{' ' + t('legal.privacy.refreshTokensRequiredToMaintainThe')}</li>
          </ul>

          <div className="legal-callout">
            <p>
              <strong>{t('common.important')}</strong>{' ' + t('legal.privacy.weOnlyAccessGoogleBusinessProfile')}</p>
          </div>

          <h3>{t('legal.privacy.33PaymentInformation')}</h3>
          <p>{' ' + t('legal.privacy.paymentCardDataIsCollectedAnd')}<strong>{t('legal.privacy.neverReachOrAreStoredOn')}</strong>{t('legal.privacy.weMaintainOnly')}</p>
          <ul>
            <li>{t('legal.privacy.aCybersourcePaymentInstrumentTokenA')}</li>
            <li>{t('legal.privacy.theLastFourDigitsOfThe')}</li>
            <li>{t('legal.privacy.cardTypeEGVisaMastercard')}</li>
            <li>{t('legal.privacy.transactionRecordsAmountsDatesStatusesAn')}</li>
          </ul>

          <h3>{t('legal.privacy.34UserUploadedContent')}</h3>
          <p>{' ' + t('legal.privacy.youMayUploadBusinessContextFiles')}</p>
          <ul>
            <li>{t('legal.privacy.theUploadedFilesThemselvesInGoogle')}</li>
            <li>{t('legal.privacy.extractedTextContentFromPdfsAnd')}</li>
          </ul>

          <h3>{t('legal.privacy.35AiGeneratedContent')}</h3>
          <p>{t('legal.privacy.weStore')}</p>
          <ul>
            <li>{t('legal.privacy.aiGeneratedReplySuggestions3Per')}</li>
            <li>{t('legal.privacy.regenerationInstructionsProvidedByUsersE')}</li>
            <li>{t('legal.privacy.theFinalTextOfPublishedReplies')}</li>
            <li>{t('legal.privacy.modelVersionAndPromptMetadataFor')}</li>
          </ul>

          <h3>{t('legal.privacy.36UsageAndAnalyticsData')}</h3>
          <ul>
            <li>{t('legal.privacy.creditConsumptionAndUsageLedgerRecords')}</li>
            <li>{t('legal.privacy.replyActivityMetricsReviewVolumeResponse')}</li>
            <li>{t('legal.privacy.auditLogEntriesActionsTakenTimestamps')}</li>
          </ul>

          <h3>{t('legal.privacy.37TechnicalAndDeviceData')}</h3>
          <ul>
            <li>{t('legal.privacy.ipAddressBrowserTypeAndVersion')}</li>
            <li>{t('legal.privacy.deviceIdentifiersForMobilePushNotificati')}</li>
            <li>{t('legal.privacy.pagesVisitedClickPatternsAndSession')}</li>
            <li>{t('legal.privacy.errorLogsAndCrashReports')}</li>
          </ul>

          <h3>{t('legal.privacy.38ReviewerDataThirdParty')}</h3>
          <p>{' ' + t('legal.privacy.whenWeIngestReviewsFromGoogle')}<strong>{t('common.not')}</strong>{' ' + t('legal.privacy.ourUser')}</p>
          <ul>
            <li>{t('legal.privacy.reviewerDisplayNameAsShownPublicly')}</li>
            <li>{t('legal.privacy.starRatingAndReviewCommentText')}</li>
            <li>{t('legal.privacy.detectedLanguageOfTheReview')}</li>
          </ul>
          <p>{' ' + t('legal.privacy.thisInformationIsPubliclyAvailableOn')}</p>

          {/* 4 */}
          <h2 id="pp-4">{t('legal.privacy.4HowWeUseYourInformation')}</h2>
          <p>{t('legal.privacy.weUseTheInformationWeCollect')}</p>

          <table>
            <thead>
              <tr>
                <th>{t('common.purpose')}</th>
                <th>{t('legal.privacy.dataUsed')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>{t('legal.privacy.provideTheService')}</strong>{' ' + t('legal.privacy.ingestReviewsGenerateAiReplySuggestions')}</td>
                <td>{t('legal.privacy.googleAccountDataReviewsBusinessContext')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.privacy.accountManagement')}</strong>{' ' + t('legal.privacy.authenticationAuthorizationRoleBasedAcce')}</td>
                <td>{t('legal.privacy.accountInformationEmailPasswordHash')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.privacy.billingAndPayments')}</strong>{' ' + t('legal.privacy.processSubscriptionsReplyPackPurchasesGe')}</td>
                <td>{t('legal.privacy.businessInformationPaymentTokensTransact')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.privacy.notifications')}</strong>{' ' + t('legal.privacy.sendEmailPushAndInApp')}</td>
                <td>{t('legal.privacy.emailDeviceTokensNotificationPreferences')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.privacy.analyticsAndInsights')}</strong>{' ' + t('legal.privacy.displayReviewVolumeResponseRatesAnd')}</td>
                <td>{t('legal.privacy.usageDataReviewMetadataReplyActivity')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.privacy.aiReplyGeneration')}</strong>{' ' + t('legal.privacy.generateContextualOnBrandReplySuggestion')}</td>
                <td>{t('legal.privacy.reviewTextStarRatingBusinessContext')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.privacy.auditAndCompliance')}</strong>{' ' + t('legal.privacy.maintainAuditTrailsForAccountabilityAnd')}</td>
                <td>{t('legal.privacy.auditLogEntriesReviewAndReply')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.privacy.serviceImprovement')}</strong>{' ' + t('legal.privacy.monitorPerformanceDebugErrorsImproveAi')}</td>
                <td>{t('legal.privacy.technicalDataErrorLogsAggregatedUsage')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.privacy.security')}</strong>{' ' + t('legal.privacy.detectAndPreventFraudAbuseAnd')}</td>
                <td>{t('legal.privacy.ipAddressesSessionDataAuthenticationLogs')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.privacy.legalCompliance')}</strong>{' ' + t('legal.privacy.respondToLegalRequestsEnforceOur')}</td>
                <td>{t('legal.privacy.asRequiredByTheSpecificLegal')}</td>
              </tr>
            </tbody>
          </table>

          <p>
            <strong>{t('legal.privacy.weDoNot')}</strong>{' ' + t('legal.privacy.useYourDataForAdvertisingSell')}</p>

          {/* 5 */}
          <h2 id="pp-5">{t('legal.privacy.5GoogleApiServicesLimitedUse')}</h2>

          <div className="legal-callout">
            <p>{' ' + t('legal.privacy.reviioRsquoSUseAndTransfer')}{' '}
              <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer">{' ' + t('legal.privacy.googleApiServicesUserDataPolicy')}</a>{t('legal.privacy.includingTheLimitedUseRequirements')}</p>
          </div>

          <p>{t('legal.privacy.specificallyReviioCommitsToTheFollowing')}</p>
          <ol>
            <li><strong>{t('legal.privacy.limitedPurpose')}</strong>{' ' + t('legal.privacy.weOnlyUseGoogleApiData')}</li>
            <li><strong>{t('legal.privacy.noSelling')}</strong>{' ' + t('legal.privacy.weDoNotSellGoogleUser')}</li>
            <li><strong>{t('legal.privacy.noAdvertising')}</strong>{' ' + t('legal.privacy.weDoNotUseGoogleUser')}</li>
            <li><strong>{t('legal.privacy.noAiMlTraining')}</strong>{' ' + t('legal.privacy.weDoNotUseGoogleUserData')}</li>
            <li><strong>{t('legal.privacy.limitedHumanAccess')}</strong>{' ' + t('legal.privacy.weDoNotAllowHumansTo')}</li>
            <li><strong>{t('legal.privacy.noUnauthorizedTransfer')}</strong>{' ' + t('legal.privacy.weDoNotTransferGoogleUser')}</li>
          </ol>

          {/* 6 */}
          <h2 id="pp-6">{t('legal.privacy.6LegalBasesForProcessingGdpr')}</h2>
          <p>{t('legal.privacy.ifYouAreLocatedInThe')}</p>
          <ul>
            <li><strong>{t('legal.privacy.contractPerformanceArt61B')}</strong>{' ' + t('legal.privacy.processingNecessaryToProvideTheService')}</li>
            <li><strong>{t('legal.privacy.legitimateInterestsArt61F')}</strong>{' ' + t('legal.privacy.serviceImprovementFraudPreventionSecurit')}</li>
            <li><strong>{t('legal.privacy.consentArt61AGdpr')}</strong>{' ' + t('legal.privacy.whereYouExplicitlyOptInFor')}</li>
            <li><strong>{t('legal.privacy.legalObligationArt61C')}</strong>{' ' + t('legal.privacy.processingRequiredToComplyWithApplicable')}</li>
          </ul>
          <p>{t('legal.privacy.youMayWithdrawConsentAtAny')}</p>

          {/* 7 */}
          <h2 id="pp-7">{t('legal.privacy.7DataSharingAmpThirdParty')}</h2>
          <p>{t('legal.privacy.weShareYourDataOnlyWith')}</p>

          <table>
            <thead>
              <tr>
                <th>{t('common.thirdParty')}</th>
                <th>{t('common.purpose')}</th>
                <th>{t('legal.privacy.dataShared')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>{t('legal.privacy.googleGoogleBusinessProfileApi')}</strong></td>
                <td>{t('legal.privacy.readingReviewsPublishingRepliesListingLo')}</td>
                <td>{t('legal.privacy.oauthTokensReplyTextToPublish')}</td>
              </tr>
              <tr>
                <td><strong>{t('common.googleCloudPlatformVertexAi')}</strong></td>
                <td>{t('legal.privacy.aiReplyGenerationViaGeminiLlm')}</td>
                <td>{t('legal.privacy.reviewTextStarRatingBusinessContextTone')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.privacy.googleCloudPlatformInfrastructure')}</strong></td>
                <td>{t('legal.privacy.hostingDatabaseCloudSqlFileStorage')}</td>
                <td>{t('legal.privacy.allServiceDataIsStoredOn')}</td>
              </tr>
              <tr>
                <td><strong>{t('common.cybersourceVisa')}</strong></td>
                <td>{t('legal.privacy.paymentProcessingCardTokenizationRecurri')}</td>
                <td>{t('legal.privacy.paymentCardDataCapturedClientSide')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.privacy.firebaseCloudMessagingGoogle')}</strong></td>
                <td>{t('legal.privacy.mobilePushNotifications')}</td>
                <td>{t('legal.privacy.deviceTokensNotificationPayloadsNoReview')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.privacy.emailServiceProvider')}</strong></td>
                <td>{t('legal.privacy.transactionalEmailsVerificationNotificat')}</td>
                <td>{t('legal.privacy.recipientEmailAddressEmailSubjectAnd')}</td>
              </tr>
            </tbody>
          </table>

          <p>
            <strong>{t('legal.privacy.weDoNot')}</strong>{' ' + t('legal.privacy.sellRentOrTradeYourPersonal')}</p>

          {/* 8 */}
          <h2 id="pp-8">{t('legal.privacy.8InternationalDataTransfers')}</h2>
          <p>{' ' + t('legal.privacy.reviioIsHostedOnGoogleCloud')}</p>
          <ul>
            <li>{t('legal.privacy.googleCloudRsquoSAdherenceTo')}</li>
            <li>{t('legal.privacy.cybersourceRsquoSComplianceWithApplicabl')}</li>
          </ul>

          {/* 9 */}
          <h2 id="pp-9">{t('legal.privacy.9DataRetentionAmpDeletion')}</h2>

          <table>
            <thead>
              <tr>
                <th>{t('legal.privacy.dataCategory')}</th>
                <th>{t('legal.privacy.retentionPeriod')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{t('legal.privacy.accountInformation')}</td>
                <td>{t('legal.privacy.untilAccountDeletionIsRequestedPlus')}</td>
              </tr>
              <tr>
                <td>{t('legal.privacy.googleOauthTokens')}</td>
                <td>{t('legal.privacy.untilDisconnectedByTheUserOr')}</td>
              </tr>
              <tr>
                <td>{t('legal.privacy.reviewsAndReplyHistory')}</td>
                <td>{t('legal.privacy.untilAccountDeletionReviewsArePublicly')}</td>
              </tr>
              <tr>
                <td>{t('legal.privacy.aiReplySuggestions')}</td>
                <td>{t('legal.privacy.untilAccountDeletion')}</td>
              </tr>
              <tr>
                <td>{t('legal.privacy.uploadedFilesPdfsImages')}</td>
                <td>{t('legal.privacy.untilDeletedByTheUserOr')}</td>
              </tr>
              <tr>
                <td>{t('legal.privacy.paymentAndBillingRecords')}</td>
                <td>{t('legal.privacy.7YearsFromTransactionDateAs')}</td>
              </tr>
              <tr>
                <td>{t('legal.privacy.auditLogs')}</td>
                <td>{t('legal.privacy.untilAccountDeletionSubjectToMinimum')}</td>
              </tr>
              <tr>
                <td>{t('legal.privacy.technicalLogsServerErrorLogs')}</td>
                <td>{t('legal.privacy.90DaysThenAutomaticallyPurged')}</td>
              </tr>
            </tbody>
          </table>

          <h3>{t('legal.privacy.accountDeletion')}</h3>
          <p>{' ' + t('legal.privacy.youMayRequestDeletionOfYour')}<a href="mailto:admin@reviio.app">{t('common.adminReviioApp')}</a>{' ' + t('legal.privacy.orThroughTheAccountSettingsPage')}</p>
          <ol>
            <li>{t('legal.privacy.weDisconnectAllGoogleConnectionsAnd')}</li>
            <li>{t('legal.privacy.weDeleteYourAccountUserRecords')}</li>
            <li>{t('legal.privacy.weRetainOnlyDataRequiredBy')}</li>
            <li>{t('legal.privacy.weConfirmDeletionCompletionViaEmail')}</li>
          </ol>

          {/* 10 */}
          <h2 id="pp-10">{t('legal.privacy.10DataSecurity')}</h2>
          <p>{t('legal.privacy.weImplementIndustryStandardTechnicalAnd')}</p>
          <ul>
            <li><strong>{t('legal.privacy.encryptionInTransit')}</strong>{' ' + t('legal.privacy.allDataIsTransmittedOverHttps')}</li>
            <li><strong>{t('legal.privacy.encryptionAtRest')}</strong>{' ' + t('legal.privacy.allDataStoredInGoogleCloud')}</li>
            <li><strong>{t('legal.privacy.oauthTokenSecurity')}</strong>{' ' + t('legal.privacy.googleOauthRefreshTokensAreEncrypted')}</li>
            <li><strong>{t('legal.privacy.pciCompliance')}</strong>{' ' + t('legal.privacy.weTargetPciDssSaqA')}</li>
            <li><strong>{t('legal.privacy.passwordSecurity')}</strong>{' ' + t('legal.privacy.userPasswordsAreCryptographicallyHashedU')}</li>
            <li><strong>{t('legal.privacy.accessControl')}</strong>{' ' + t('legal.privacy.roleBasedAccessControlRbacEnforced')}</li>
            <li><strong>{t('legal.privacy.apiRateLimiting')}</strong>{' ' + t('legal.privacy.protectionAgainstBruteForceAttacksAnd')}</li>
            <li><strong>{t('legal.privacy.inputValidation')}</strong>{' ' + t('legal.privacy.allUserInputsAndApiRequest')}</li>
            <li><strong>{t('legal.privacy.infrastructureSecurity')}</strong>{' ' + t('legal.privacy.hostedOnGoogleCloudPlatformWith')}</li>
            <li><strong>{t('legal.privacy.monitoringAndAlerting')}</strong>{' ' + t('legal.privacy.realTimeMonitoringForSecurityEvents')}</li>
          </ul>

          {/* 11 */}
          <h2 id="pp-11">{t('legal.privacy.11YourRights')}</h2>
          <p>{t('legal.privacy.dependingOnYourJurisdictionYouMay')}</p>
          <ul>
            <li><strong>{t('legal.privacy.rightOfAccess')}</strong>{' ' + t('legal.privacy.requestACopyOfThePersonal')}</li>
            <li><strong>{t('legal.privacy.rightToRectification')}</strong>{' ' + t('legal.privacy.requestCorrectionOfInaccurateOrIncomplet')}</li>
            <li><strong>{t('legal.privacy.rightToErasureLdquoRightTo')}</strong>{' ' + t('legal.privacy.requestDeletionOfYourDataSee')}</li>
            <li><strong>{t('legal.privacy.rightToRestrictProcessing')}</strong>{' ' + t('legal.privacy.requestThatWeLimitHowWe')}</li>
            <li><strong>{t('legal.privacy.rightToDataPortability')}</strong>{' ' + t('legal.privacy.requestYourDataInAStructured')}</li>
            <li><strong>{t('legal.privacy.rightToObject')}</strong>{' ' + t('legal.privacy.objectToProcessingBasedOnLegitimate')}</li>
            <li><strong>{t('legal.privacy.rightToWithdrawConsent')}</strong>{' ' + t('legal.privacy.withdrawConsentAtAnyTimeE')}</li>
            <li><strong>{t('legal.privacy.rightToLodgeAComplaint')}</strong>{' ' + t('legal.privacy.fileAComplaintWithYourLocal')}</li>
          </ul>
          <p>{' ' + t('legal.privacy.toExerciseAnyOfTheseRights')}<a href="mailto:admin@reviio.app">{t('common.adminReviioApp')}</a>{t('legal.privacy.weWillRespondWithin30Days')}</p>

          <h3>{t('common.googleAccountPermissions')}</h3>
          <p>{' ' + t('legal.privacy.youMayRevokeReviioRsquoS')}{' '}
            <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener noreferrer">{t('common.googleAccountPermissions')}</a>{' '}{' ' + t('legal.privacy.pageOrByDisconnectingTheGoogle')}</p>

          {/* 12 */}
          <h2 id="pp-12">{t('legal.privacy.12ChildrenRsquoSPrivacy')}</h2>
          <p>{' ' + t('legal.privacy.reviioIsAB2bServiceDesigned')}</p>

          {/* 13 */}
          <h2 id="pp-13">{t('legal.privacy.13ChangesToThisPolicy')}</h2>
          <p>{' ' + t('legal.privacy.weMayUpdateThisPrivacyPolicy')}</p>
          <ul>
            <li>{t('legal.privacy.postingTheUpdatedPolicyOnOur')}</li>
            <li>{t('legal.privacy.sendingAnEmailNotificationToAccount')}</li>
            <li>{t('legal.privacy.displayingAnInAppNotificationOn')}</li>
          </ul>
          <p>{' ' + t('legal.privacy.weEncourageYouToReviewThis')}</p>

          {/* 14 */}
          <h2 id="pp-14">{t('legal.privacy.14ContactUs')}</h2>
          <p>{' ' + t('legal.privacy.ifYouHaveQuestionsConcernsOr')}</p>
          <ul>
            <li><strong>{t('common.email2')}</strong> <a href="mailto:admin@reviio.app">{t('common.adminReviioApp')}</a></li>
            <li><strong>{t('common.generalSupport')}</strong> <a href="mailto:support@reviio.app">{t('common.supportReviioApp')}</a></li>
            <li><strong>{t('common.website')}</strong> <a href="https://reviio.com">{t('common.httpsReviioCom')}</a></li>
          </ul>
          <p>{' ' + t('legal.privacy.forGdprRelatedInquiriesYouMay')}<a href="mailto:admin@reviio.app">{t('common.adminReviioApp')}</a>.
          </p>

        </div>
      </div>

      {/* Footer */}
      <SiteFooter />
    </div>
  );
}
